import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import { AppProvider } from "./context/AppContext";
import { registerServiceWorker } from "./serviceWorkerRegistration";

const rootEl = document.getElementById("root");
const isPrerendered = rootEl.hasAttribute("data-prerendered");

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </HelmetProvider>
  </React.StrictMode>
);

if (isPrerendered) {
  // Pre-rendered HTML exists — hydrate to preserve content and avoid flash
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  // Normal SPA mode (dev server, or pre-render failed)
  const root = ReactDOM.createRoot(rootEl);
  root.render(app);
}

// PWA Phase 1b (May 7, 2026): register the service worker AFTER hydration so
// it never blocks first paint. Production-only by default. See
// PWA_DESIGN.md §Implementation Phases.
registerServiceWorker();
